@if (hasAutoSaveInfo()) {
  <span class="footer__auto-save-info">
    {{ 'app.evaluation_panel.saved' | translate }}
  </span>
}

<rt-group class="footer__actions">
  <rt-button variant="plain" [disabled]="isLoading()" (click)="cancel.emit()">
    {{ 'app.evaluation_panel.cancel' | translate }}
  </rt-button>
  <rt-button variant="outline" [disabled]="isLoading()" (click)="clearForm.emit()">
    {{ 'app.evaluation_panel.clear_form' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    [disabled]="isSubmitDisabled()"
    [loading]="isLoading()"
    (click)="submit.emit()"
  >
    {{ submitLabelKey() | translate }}
  </rt-button>
</rt-group>
